/* IE DETECTION!!! */
(function () {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
	var theclass = "IE";
    if (msie > 0) {
        theclass += parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		document.querySelector('body').classList.add( theclass );
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        theclass += parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		document.querySelector('body').classList.add( theclass );
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
		theclass += parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		document.querySelector('body').classList.add( theclass );
    }
})();

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	$(document).ready(function () {
		//Call function with browser is resized.
		$(window).resize(function (event) {
		});
		
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		var headerBooking = $('#header');
		console.log(headerBooking.hasClass('header-booking'));
		if( $(window).width() > 767 ){
			scrollDownAction(20, 'scroll');
		}else{
			if(headerBooking.hasClass('header-booking') == false){
				var logo = document.querySelector('.js-scroll-logo img');
				var mobilelogoSrc = logo.dataset.scroll;
				logo.setAttribute("src",mobilelogoSrc);
			}
		}

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



$('.top-reasons__slider').on('init', function(event, slick, currentSlide, nextSlide){
	var counter = 0;
    $('.top-reasons__container').each(function(){
		counter++;
        $('.top-reasons__dots').append('<a href="javascript:;" aria-label="Go to slide '+ counter + '" class="top-reasons__dot">'+ counter +'</a>')
    }).promise().done(function(){
        $('.top-reasons__dot').on('click', function(){
            var indesxin = $(this).index();
            $('.top-reasons__slider').slick('slickGoTo',indesxin);
        });
        $('.top-reasons__dot').first().addClass('active');
    });
});

$('.top-reasons__slider').on('beforeChange', function(){
  $('.top-reasons__dot').removeClass('active');
});

$('.top-reasons__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  var nein = currentSlide + 1;
  $('.top-reasons__dot:nth-child(' + nein + ')').addClass('active');
});



/* Home Map */
var legendItems = document.querySelectorAll('.map-ov__list a, .map-ov__dot a');
function mapfuncIn(){
	var selectRef = this.dataset.reference;
	console.log(this.dataset);
	document.querySelector(selectRef).classList.add('active');
}
function mapfuncOut(){
	var selectRef = this.dataset.reference;
	console.log(this.dataset);
	document.querySelector(selectRef).classList.remove('active');
}
legendItems.forEach((el)=>{
	el.addEventListener('mouseover',mapfuncIn);
	el.addEventListener('mouseout',mapfuncOut);
});

/* Menu Mobile */
var menuclose = document.querySelector('.header .close-btn');
if (menuclose) {
	menuclose.addEventListener('click', function () {
		var menuObj = document.querySelector('.header');
		menuObj.classList.remove('active');
	});
	document.querySelector('.hamburger__btn').addEventListener('click', function () {
		var menuObj = document.querySelector('.header');
		menuObj.classList.add('active');
	});
}
$('.scrollto').on('click', function(e){
	e.preventDefault();
	var targ = $(this).attr('href');
	$("html, body").animate({ scrollTop: $(targ).offset().top - 110 }, 800);
});

$('.sandwich-btn').on('click', function(e){
	e.preventDefault();
	var tagt = $(this).attr('href');
	$(tagt).slideToggle();
	$(this).toggleClass('active');
});


// TABS ROOMS
//var firstTab = document.querySelector('.list__tabs__item:first-child a');
var firstTab = document.querySelector('#tab-ShoppingampDining a');
if (!firstTab) {
	firstTab = document.querySelector('.list__tabs__item:first-child .list__tabs__btn');
}
if (firstTab) {
	firstTab.classList.add('active');
	firstTab.setAttribute("aria-selected", "true");
	var filterFirts = firstTab.getAttribute("data-target");
	var sectionFirst = firstTab.closest('section');

	sectionFirst.querySelectorAll('.list__item').forEach((allDivsFirst) => {
		allDivsFirst.classList.remove('list__item__hide');
	})

	var hideSelectorsFirst = '.list__item:not(' + filterFirts + ')';
	sectionFirst.querySelectorAll(hideSelectorsFirst).forEach((hideDivsFirst) => {
		hideDivsFirst.classList.add('list__item__hide');
		document.querySelector('.list__ofrooms').appendChild(hideDivsFirst);
	})

	var tabbuttons = document.querySelectorAll('.list__tabs__btn');
	var tc = 0;

	for (tc; tc < tabbuttons.length; tc++) {
		tabbuttons[tc].addEventListener('click', function () {

			if (!this.classList.contains('active')) {

				tabbuttons.forEach((tabbuttons) => { 
					 tabbuttons.classList.remove('active');
					tabbuttons.setAttribute("aria-selected", "false");
				 })

				this.classList.add('active');
				this.setAttribute("aria-selected", "true");
				var filterdis = this.getAttribute("data-target") == '*' ? '' : this.getAttribute("data-target");
				var section = this.closest('section');

				if( ! filterdis){
					document.querySelectorAll('.list__item:not(.list__item__hide)').forEach((hideDivs)=>{
						document.querySelector('.list__quads').appendChild(hideDivs);
					});
				}
				section.querySelectorAll('.list__item').forEach((allDivs) => {
					allDivs.classList.remove('list__item__hide');
				})

				if (filterdis) {
					var hideSelectors = '.list__item:not(' + filterdis + ')';
					console.log(section);
					section.querySelectorAll(hideSelectors).forEach((hideDivs) => {
						console.log(hideDivs);
						hideDivs.classList.add('list__item__hide');
						document.querySelector('.list__quads').appendChild(hideDivs);
					});
				}

				//Toggle animations first quad
				var firtsQuad = document.querySelector('.list__item' + filterdis);
				firtsQuad.querySelectorAll('.animate-fade').forEach((animated) => {
					animated.classList.add('fade-in', 'visible');
				});

				var menuDad = document.querySelector('.list__tabs');

				if(menuDad){
					menuDad.classList.remove('open');
					var newlabel = this.textContent;
					document.querySelector('.list__tabs__select span').textContent = newlabel;
				}
			}
		});
	}
}
/* TABS ROOMS mobile toggle */
var menuToggle = document.querySelector('.list__tabs__select');
if(menuToggle){
	menuToggle.addEventListener('click', (e)=>{
		e.preventDefault();
		var menuDad = document.querySelector('.list__tabs');
		if( menuDad.classList.contains("open") ){
			menuDad.classList.remove('open');
		}else{
			e.preventDefault();
			menuDad.classList.add('open');
		}
	});
}

/* Press Form */
var pressbtn = document.querySelector('.pressform__toggle');
if(pressbtn){
	document.querySelector('.intro-content__main').appendChild(pressbtn);
	var theform = document.getElementById('pressform');
	pressbtn.addEventListener('click', (e)=>{
		e.preventDefault();
		pressbtn.classList.toggle('active');
		theform.classList.toggle('active');
	})
}

/* oFFERS SLIcK destroy for mobile */
function pressSlickResponsive(){
	var viewportWidth = jQuery(window).width();
	console.log(viewportWidth);
	if(viewportWidth > 767){
		if(! $('.offers__list__slider').hasClass('slick-slider')){
			$('.offers__list__slider').on('init', function(ev, slick, cur, nex){
				$(this).find('.slick-slide[aria-hidden="true"] a').attr('tabindex','-1');
        		$(this).find('.slick-slide[aria-hidden="false"] a').removeAttr('tabindex');
			});
			$('.offers__list__slider').slick();
			$('.offers__list__slider').on('afterChange', function(ev, slick, cur, nex){
				$(this).find('.slick-slide[aria-hidden="true"] a').attr('tabindex','-1');
        		$(this).find('.slick-slide[aria-hidden="false"] a').removeAttr('tabindex');
			});
		}
	}else{
		if( $('.offers__list__slider').hasClass('slick-initialized') ){
			$('.offers__list__slider').slick('unslick');
		}
	}
}
pressSlickResponsive();
jQuery(window).on('resize', function() {
	pressSlickResponsive();
});

/* Forms Aria labels */

addEventListener("DOMContentLoaded", (event) => {
	let form1= document.getElementById('footer')
	if (document.getElementsByClassName('footer') != null) {
		let submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
		submitSignUp.setAttribute('aria-label', 'Subscribe to receive emails from our inn');
	}
	form1 = document.getElementById('shemcreekinngroupsrequestforproposal-form')
	if (form1) {
		let submitSignUp = form1.getElementsByClassName("btn ")[0];
		submitSignUp.setAttribute('aria-label', 'request for proposal');
	}
	
	if (document.getElementById('form_id-651')) {
		let submitSignUp = document.querySelector("#form_id-651  button.btn");
		submitSignUp.setAttribute('aria-label', 'Submit contact information');
	}
});